import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './BodyLevel.css';


const bodyParts = ["Chest", "Back", "Arms", "Legs", "Shoulders", "Abs"];

const BodyLevel = ({ updateUserData }) => {
    const navigate = useNavigate();
    const [selectedPart, setSelectedPart] = useState("");

    const handleClick = () => {
        updateUserData({ bodyPart: selectedPart });
        navigate('/generate');
    };

    return (
        <div  style={{backgroundColor:"white",padding:"2rem"}}>
            <div className="body-title">Choose a Body Part</div>
            <div className="body-options-container">
                {bodyParts.map(part => (
                    <div key={part} className="body-option">
                        <label className="custom-checkbox">
                            <input
                                type="checkbox"
                                value={part}
                                checked={selectedPart === part}
                                onChange={() => setSelectedPart(part)}
                            />
                            <span className="checkbox-label">{part}</span>
                        </label>
                    </div>
                ))}
            </div>
            <button onClick={() => navigate('/yourlevel')} className="body-button back-button">Back</button>
            <button onClick={handleClick} className="body-button nextbutton" disabled={!selectedPart}>Generate</button>
        </div>
    );
};

export default BodyLevel;
